import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { SeverityEnum } from '../_enums/severity.enum';
import { ToasterTypeEnum } from '../_enums/toaster-type.enum';
import { ConfigService } from 'app/config.service';

interface NotificationText {
	text?: string;
	headerText?: string;
	buttonText?: string;
}

@Injectable({
	providedIn: 'root'
})
export class NotificationService {

	// Default Notification
	public notificationState = false;
	public notificationText: NotificationText = {};
	public severity: SeverityEnum;
	public toasterType: ToasterTypeEnum;

	public teamsPremiumPackageUrl = '#';

	public isPushSubscribed = false;
	public hasSeenSlidedown = false;

	public notificationBoxConfirmed = new Subject<void>();

	//Announcement Notification
	public announcementNotificationState: boolean = false;
	public announcementNotificationText: string = "";
	public announcementNotificationButtonText: string = "";
	public announcementNotificationButtonShown: Boolean = false;
	public announcementNotificationButtonClick: Function = null;
	public announcementNotificationTimeout: number = 12000;

	public announcementNotificationShown = new Subject<void>();

	constructor(private configService: ConfigService) {}

	clearNotifications(): void {
		this.notificationState = false;
		this.notificationText = {};
	}

	showNotification(
		toasterType: ToasterTypeEnum,
		severity: SeverityEnum,
		text: NotificationText,
		ttl: number = 3000, // provide -1 to persist notification
	): void {
		// do not show notification if guest feature 402-error-triggered modal is open
		if (this.configService.modalGuestConversionState) {
			return;
		}
		this.toasterType = toasterType;
		this.severity = severity;
		this.notificationText = text;
		this.notificationState = true;
		if (ttl !== -1) {
			setTimeout(() => {
				this.notificationState = false;
			}, ttl);
		}
	}

	showOneSignalPrompt(): void {
		if (!(window as any).OneSignal) return;
		const OneSignal = (window as any).OneSignal || [];
		// If we're on an unsupported browser, do nothing
		if (!OneSignal.isPushNotificationsSupported() || this.hasSeenSlidedown)
			return;
		this.hasSeenSlidedown = true;
		const that = this;
		OneSignal.push(() => {
			OneSignal.showSlidedownPrompt({ force: true });
		});
		OneSignal.push(() => {
			OneSignal.on('popoverAllowClick', () => {
				that.showNativePrompt();
			});
		});
	}

	showNativePrompt(): void {
		if (!(window as any).OneSignal) return;
		const OneSignal = (window as any).OneSignal || [];
		OneSignal.push(() => {
			OneSignal.push(['registerForPushNotifications']);
		});
	}

	muteOneSignalNotifications(): void {
		if (!(window as any).OneSignal) return;
		const OneSignal = (window as any).OneSignal || [];
		OneSignal.push(['setSubscription', false]);
	}

	unmuteOneSignalNotifications(): void {
		if (!(window as any).OneSignal) return;
		const OneSignal = (window as any).OneSignal || [];
		OneSignal.push(['setSubscription', true]);
	}

	checkPushNotificationStatus(): void {
		if (!(window as any).OneSignal) return;
		const OneSignal = (window as any).OneSignal || [];
		const that = this;
		// If we're on an unsupported browser OR already subscribed, do nothing
		if (!OneSignal.isPushNotificationsSupported()) return;
		OneSignal.push(() => {
			OneSignal.isPushNotificationsEnabled((isEnabled: any) => {
				if (!isEnabled) {
					that.showOneSignalPrompt();
				}
			});
		});
	}

	//Announcement Notification
	showAnnouncementNotification(
		text: string,
		timeout: number | null,
		buttonShown: boolean, 
		buttonText: string | null,
		buttonClick: Function | null ) {
			this.announcementNotificationText = text;
			this.announcementNotificationButtonShown = buttonShown;
			this.announcementNotificationButtonText = buttonText;
			this.announcementNotificationButtonClick = buttonClick;
			this.announcementNotificationTimeout = timeout;
			this.announcementNotificationState = true;
			this.announcementNotificationShown.next();
	}

}
